import { Getter, GetterTree } from 'vuex'

import { IMatchFieldsStore, IIssue } from '@/features/matchFields/store'

import { ERROR } from '@/constants'

import {
  GET_RESERVATION_TYPES,
  GET_ISSUES,
  GET_MATCHER_FOR_DISPLAY,
  GET_MATCHER,
  GET_PERMISSION_TO_SEND,
  GET_DATE_TIME_FORMAT,
  GET_SELECTED_TZ,
  GET_ERRORS
} from '@/system/store/getter-types'

const getReservationTypes: Getter<IMatchFieldsStore, any> = ({ types }: IMatchFieldsStore) => {
  return types
}

const getIssues: Getter<IMatchFieldsStore, any> = ({ issues }: IMatchFieldsStore) => {
  return issues
}

const getMatcherForDisplay: Getter<IMatchFieldsStore, any> = ({ matcherForDisplay }: IMatchFieldsStore) => {
  return matcherForDisplay
}

const getMatcher: Getter<IMatchFieldsStore, any> = ({ matcherForDisplay }: IMatchFieldsStore) => {
  const matcher: { rooms: string[], [key: string]: any } = {
    rooms: [],
    set room_name (v: string) { this.rooms.push(v) }
  }
  return matcherForDisplay.reduce((acc, { assignedField }) => Object.assign(acc, assignedField), matcher)
}

const getPermissionToSend: Getter<IMatchFieldsStore, any> = ({ isValid }: IMatchFieldsStore) => {
  return isValid
}

const getDateTimeFormat: Getter<IMatchFieldsStore, any> = ({ dateTimeFormat }: IMatchFieldsStore) => {
  return dateTimeFormat
}

const getSelectedTZ: Getter<IMatchFieldsStore, any> = ({ selectedTZ }: IMatchFieldsStore) => {
  return selectedTZ
}

const getErrors: Getter<IMatchFieldsStore, any> = ({ issues }: IMatchFieldsStore) => {
  return issues.filter(({ type }: IIssue) => type === ERROR)
}

const getters: GetterTree<IMatchFieldsStore, any> = {
  [GET_RESERVATION_TYPES]: getReservationTypes,
  [GET_ISSUES]: getIssues,
  [GET_MATCHER_FOR_DISPLAY]: getMatcherForDisplay,
  [GET_MATCHER]: getMatcher,
  [GET_PERMISSION_TO_SEND]: getPermissionToSend,
  [GET_DATE_TIME_FORMAT]: getDateTimeFormat,
  [GET_SELECTED_TZ]: getSelectedTZ,
  [GET_ERRORS]: getErrors
}

export default getters
